export default __webpack_public_path__ + "static/mobile-hero-57d9151c009af594e16001e8039789e2.webp";